import api from './api';
import { Budget, BudgetStatus } from '@/types';

export interface BudgetItemInput {
  product_id?: number;
  description: string;
  quantity: number;
  unit_price: number;
}

export interface BudgetCreate {
  owner_id?: number;
  client_name?: string;
  client_phone?: string;
  valid_days?: number;
  notes?: string;
  discount_amount?: number;
  items: BudgetItemInput[];
}

export interface BudgetUpdate {
  owner_id?: number;
  client_name?: string;
  client_phone?: string;
  valid_days?: number;
  notes?: string;
  discount_amount?: number;
  status?: BudgetStatus;
  items?: BudgetItemInput[];
}

export const budgetsService = {
  async getBudgets(): Promise<Budget[]> {
    const res = await api.get<Budget[]>('/budgets');
    return res.data;
  },
  async getBudget(id: number): Promise<Budget> {
    const res = await api.get<Budget>(`/budgets/${id}`);
    return res.data;
  },
  async createBudget(data: BudgetCreate): Promise<Budget> {
    const res = await api.post<Budget>('/budgets', data);
    return res.data;
  },
  async updateBudget(id: number, data: BudgetUpdate): Promise<Budget> {
    const res = await api.put<Budget>(`/budgets/${id}`, data);
    return res.data;
  },
  async deleteBudget(id: number): Promise<void> {
    await api.delete(`/budgets/${id}`);
  },
};
